module.exports = __webpack_public_path__ + "img/144.82ae3815.jpg";